import { useAuth } from './useAuth';

export function useActivityTracker() {
  const { token } = useAuth();

  const trackActivity = async (action_type, course_name = null, page_url = null) => {
    if (!token) return;

    try {
      await fetch('http://localhost:5000/api/analytics/track', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ action_type, course_name, page_url })
      });
    } catch (err) {
      console.error('Failed to track activity:', err);
    }
  };

  return { trackActivity };
}
